import React, { useCallback } from 'react';
import { Dialog, DialogContent, Grid, DialogActions, DialogTitle } from '@mui/material';
import { IconButton } from '@totalsoft/rocket-ui';
import { useReactiveVar } from '@apollo/client';
import { metadataModalOpenVar } from '../../variables';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import FlexBox from 'components/common/FlexBox';
import MetadataListBrowser from 'features/metadata/list/components/MetadataListBrowser';

const MetadataModalComponent = () => {
  const { t } = useTranslation();
  const metadataModal = useReactiveVar(metadataModalOpenVar);

  const handleClose = useCallback(() => {
    metadataModalOpenVar({ open: false });
  }, []);

  return (
    <Dialog open={metadataModal.open} fullWidth maxWidth='lg' scroll={'body'} TransitionProps={{ exit: false }}>
      <Grid container>
        <DialogTitle color='primary' fontWeight='bold' variant='subtitle1'>
          {t('Metadata.Title')}
        </DialogTitle>
        <FlexBox grow={1} justifyContent='end'>
          <DialogActions>
            <FlexBox id='metadata-actions-slot' gap={0.5} />
            <IconButton color='primary' variant='text' tooltip={t('Close')} size='tiny' onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </DialogActions>
        </FlexBox>
      </Grid>
      <DialogContent>
        <MetadataListBrowser withExport />
      </DialogContent>
    </Dialog>
  );
};

export default MetadataModalComponent;
